import React, {useContext, useState} from 'react';
import "./StatementComponent.css"
import {Context} from "../../index";
import ModalNoStatement from "../Modal/ModalNoStatement";

const StatementComponent = (
    {
        StatementTask,
        btnJob,
        statementJob,
        UserStatement,
        btnYes,
        btnNo,
        statementNo,
        statementYes,
        show,
        setShow,
        stText,
        setStText,
        TaskClose,
        TaskCloseBtn,
        TaskNew,
        TaskNewBtn
    }
) => {

    const {userStore} = useContext(Context)

    const [showNoState, setShowNoState] = useState(false)

    let StatementTaskShow

    if (StatementTask.filter(i => i.status).length === 0) {
        StatementTaskShow = <div className="statement__block__all">
            <div className="statement__block">
                <div className="name__statement">Отправить на утверждение</div>
                <button
                    className="statement__btn"
                    onClick={() => setShow(setShow => !setShow)}
                >
                    {show ? "Развернуть" : "Свернуть"}
                </button>
            </div>
            <div className="statement__text__block" style={{display: show ? "none" : "block"}}>
                <textarea onChange={e => setStText(e.target.value)} value={stText} type="text"
                          placeholder="Комментарий по заявке на утверждение..."/>
                <div className="st__btn__block">
                    <button className="btn__yes" onClick={() => btnJob(statementJob)}>Отправить</button>
                </div>
            </div>
        </div>
    }

    if (StatementTask.filter(i => i.status === 'JOB').length) {
        StatementTaskShow = <div className="statement__block__all__job">
            <div className="statement__block">
                <div className="name__statement">
                    Отправил на утверждение: {UserStatement.map(i => <>
                        {i.user.map(j =>
                            <span key={j.id}> {j.firstName} {j.secondName}</span>
                        )}
                    </>
                )}
                    {StatementTask.map(i => <span key={i.id}> {new Date(i.createdAt).toLocaleString()}</span>)}
                </div>
            </div>
            <div className="statement__text__block__job">
                {StatementTask.map(i =>
                    <div key={i.id} className="one__task__name__block">
                        {i.text === ''
                            ? <div className="one__task__name__block__text">Комментарий не оставлен</div>
                            : <div className="one__task__name__block__text">{i.text}</div>
                        }

                    </div>
                )}
                {userStore.user.role !== "USER" &&
                    <div className="st__btn__block">
                        <button className="btn__yes" onClick={() => btnYes(statementYes)}>Согласовать</button>
                        <button className="btn__no" onClick={() => setShowNoState(true)}>Отказать</button>
                    </div>
                }

            </div>
        </div>
    }

    if (StatementTask.filter(i => i.status === 'YES').length) {
        StatementTaskShow = <div className="statement__block__all__yes">
            <div className="st__bl__l">
                <div className="statement__block">
                    <div className="name__statement__yes">
                        Отправил на утверждение: {UserStatement.map(i => <>
                            {i.user.map(j =>
                                <span key={j.id}> {j.firstName} {j.secondName}</span>
                            )}
                        </>
                    )}
                        {StatementTask.map(i => <span key={i.id}> {new Date(i.createdAt).toLocaleString()}</span>)}
                    </div>
                </div>
                <div className="statement__text__block__yes">
                    {StatementTask.map(i =>
                        <div key={i.id} className="one__task__name__block">
                            {i.text === ''
                                ? <div className="one__task__name__block__text">Комментарий не оставлен</div>
                                : <div className="one__task__name__block__text">{i.text}</div>
                            }
                        </div>
                    )}

                    <div className="st__ex__block">
                        <div className="name__statement__yes__ex">
                            Согласовал: {UserStatement.map(i => <>
                                {i.user.map(j =>
                                    <span key={j.id}> {j.firstName} {j.secondName}</span>
                                )}
                            </>
                        )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="result__block__yes">
                <div className="result__text">СОГЛАСОВАНО</div>
            </div>
        </div>
    }

    if (StatementTask.filter(i => i.status === 'NO').length) {
        StatementTaskShow = <div className="statement__block__all__no">
            <div className="st__bl__l">
                <div className="statement__block">
                    <div className="name__statement__yes">
                        Отправил на утверждение: {UserStatement.map(i => <>
                            {i.user.map(j =>
                                <span key={j.id}> {j.firstName} {j.secondName}</span>
                            )}
                        </>
                    )}
                        {StatementTask.map(i => <span key={i.id}> {new Date(i.createdAt).toLocaleString()}</span>)}
                    </div>
                </div>
                <div className="statement__text__block__yes">
                    {StatementTask.map(i =>
                        <div key={i.id} className="one__task__name__block">
                            {i.text === ''
                                ? <div className="one__task__name__block__text">Комментарий не оставлен</div>
                                : <div className="one__task__name__block__text">{i.text}</div>
                            }
                        </div>
                    )}

                    <div className="st__ex__block">
                        <div className="name__statement__no__ex">
                            Отказал: {UserStatement.map(i => <>
                                {i.user.map(j =>
                                    <span key={j.id}> {j.firstName} {j.secondName}</span>
                                )}
                            </>
                        )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="result__block__yes">
                <div className="result__text result__text__no">ОТКАЗАНО</div>
            </div>
        </div>
    }

    return (
        <>
            {StatementTaskShow}
            <ModalNoStatement
                showNoState={showNoState}
                setShowNoState={setShowNoState}
                btnNo={btnNo}
                statementNo={statementNo}
                TaskCloseBtn={TaskCloseBtn}
                TaskClose={TaskClose}
                TaskNew={TaskNew}
                TaskNewBtn={TaskNewBtn}
            />
        </>
    );
};

export default StatementComponent;